import React from 'react';
import { AppleDownloadButton } from '../Buttons/AppleDownloadButton';
import { GoogleDownloadButton } from '../Buttons/GoogleDownloadButton';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { observer } from 'mobx-react';

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: auto;
  animation: ${fadeInRight} 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.4s both;
`;

const Text = styled.p`
  font-weight: 800;
  line-height: 1.1;
  color: #fff;
  margin: 0 0 40px;
  text-align: right;
  font-size: 48px;
  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.5));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ${float} 6s ease-in-out infinite;

  @media (min-width: 600px) {
    font-size: calc(1.45rem + 3vw);
    line-height: calc(1.25rem + 3vw);
  }
`;

const ButtonContainer = styled.div`
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export type AuthOverlayRightProps = {
  text: string;
};

export const AuthOverlayRight: React.FC<AuthOverlayRightProps> = observer(({ text }) => {
  return (
    <Container>
      <Text dangerouslySetInnerHTML={{ __html: text?.replace(/\n/g, '<br />') }} />
      <ButtonContainer>
        <AppleDownloadButton />
        <GoogleDownloadButton />
      </ButtonContainer>
    </Container>
  );
});
